<template>
  <div id="tab1" class="t-color-bodyGrayA pdt-16 pdb-32">
    <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
        <div>
          <button
            class="mgr-4 mdc-button mdc-button--raised"
          >계정 관리</button>
          <button
            class="mdc-button mdc-button--raised btn-red"
          >로그인 또는 로그아웃</button>
        </div>
        <div class="t-subtitle3 t-color-headlineBlack l-spacing48  pdb-8 font-m">서비스에 로그아웃</div>
        <div
          class="t-body3 t-color-bodyGrayA l-spacing42 font-r"
        >서비스를 사용 중인 기기에 따라 로그아웃하거나 계정을 삭제하거나 다른 조치를 취할 수 있습니다.</div>
        <div class="pdt-24">
          <button
            class="t-color-quizGray bg-documentGray mdc-button mdc-button--raised"
          >
            <i class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개
          </button>
        </div>
      </div>
    </div>
    <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
        <div>
          <button
            class="t-color-white bg-paymentBlue3 mdc-button mdc-button--raised"
          >설정</button>
          <button
            class="mdc-button mdc-button--raised"
          >설정 변경</button>
        </div>
        <div class="t-subtitle3 t-color-headlineBlack l-spacing48  pdb-8 font-m">서비스 설정 변경하기</div>
        <div class="t-body3 t-color-bodyGrayA l-spacing42 font-r">
          전화 번호를 추가하거나 알림 수신 설정을 변경합니다.
          <a
            href="https://www.google.com/search?source"
          >https://www.google.com/search?source</a>
        </div>
      </div>
    </div>
    <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
        <div>
          <button
            class="mdc-button mdc-button--raised"
          >문제 해결</button>
          <button
            class="mdc-button mdc-button--raised btn-red"
          >동기화</button>
        </div>
        <div class="t-subtitle3 t-color-headlineBlack l-spacing48  pdb-8 font-m">서비스 설정 변경하기</div>
        <div class="t-body3 t-color-bodyGrayA l-spacing42 font-r">
          안드로이드 앱이 자동으로 동기화되지 않으면 다음과 같은 문제가 발생할 수 있습니다. 각 단계를
          수행한 …
        </div>
        <div class="pdt-24">
          <button
            class="t-color-quizGray bg-documentGray mdc-button mdc-button--raised"
          >
            <i class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {MDCRipple} from '@material/ripple'
export default {
    data(){
        return{
          rs:''  
        }
    },
    mounted() {
        this.setMaterialUi()
    },
    methods: {
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
   
}
</script>
<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 var(--Shadow1);
            background-color: var(--DocumentWhite);
        }

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid var(--Divider);
}
.b-radius2 {
  border-radius: 2px;
}
.l-spacing36 {
  letter-spacing: -0.36px;
}
.font-16 {
  font-size: 16px;
}
.bg-paymentBlue3 {
  background-color: var(--ContentBlue);
}
.queryCount {
  border-radius: 50%;
}
.font-11 {
  font-size: 11px !important;
}
.ssss{
    display: none;
}
</style>